import { render } from "./positions.vue?vue&type=template&id=c5f6b34c"
import script from "./positions.vue?vue&type=script&lang=js"
export * from "./positions.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/sale/tender/create/tabs/positions/positions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c5f6b34c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c5f6b34c', __exports__)) {
    console.log('reload')
    api.reload('c5f6b34c', __exports__)
  }
  
  module.hot.accept("./positions.vue?vue&type=template&id=c5f6b34c", () => {
    console.log('re-render')
    api.rerender('c5f6b34c', render)
  })

}


export default __exports__